
import { useParams } from "react-router-dom";
import { useMovimientosXBodegaYProducto, useRemesasXBodegaYProducto } from "../../../hooks";
import { CargandoMedio } from "../../components";
import { DisenioBodegaYProducto } from "../../layout";
import { TablaMovimientosStock, TablaRemesasXProducBodega } from "../../components/productos/inventario";




export const HistorialXProductoYBodega = () => {


    const { id } = useParams();
    const { movimientosXBodegaYProducto, page, chagePage } = useMovimientosXBodegaYProducto(id);
    const { data } = useRemesasXBodegaYProducto(id);



    return (
        <DisenioBodegaYProducto>

            {(movimientosXBodegaYProducto.isLoading)
            ?   <CargandoMedio titulo="Cargando Movimientos..." />
            :   <>
                <TablaRemesasXProducBodega data={data} />
                <TablaMovimientosStock data={movimientosXBodegaYProducto.data || []} page={page} chagePage={chagePage} />
                </>
            }
        </DisenioBodegaYProducto>
    )


}
